import { createContext, useContext } from 'react'

// Container the plan's right-side drawers (Replace / Import) render into, so they sit
// inside the plan content box (below the host header) instead of covering it.
export const PlanDrawerContainerContext = createContext<HTMLElement | null>(
  null,
)

export const usePlanDrawerContainer = () =>
  useContext(PlanDrawerContainerContext)
